import { useCallback } from 'react';

import {
	CONVERSATION_ASSISTANT_CONTAINER_ID,
	CONVERSATION_ASSISTANT_CONTAINER_WIDTH,
} from '@atlassian/conversation-assistant/utils';
import { ConversationAssistantUIModes } from '@atlassian/conversation-assistant';
import { useRovoExperienceAPIStore } from '@atlassian/rovo-experience-api';

import { expValEquals } from '@confluence/feature-experiments';
import { fg } from '@confluence/feature-gating';
import { useRightSidebarContext } from '@confluence/page-layout-context';

import { useCreateRovoExperienceSidebarController } from './useCreateRovoExperienceSidebarController';

/**
 * Note: this only works if Rovo is enabled, look up RovoButton as an example
 * @returns toggleConversationAssistant which will open the ride side panel with the Conversation Assistant open
 */
export const useToggleConversationAssistant = () => {
	const rightSidebarContext = useRightSidebarContext();
	const { panelId } = rightSidebarContext.getCurrent() || {};
	const { toggleConversationAssistantUIMode } = useRovoExperienceAPIStore();
	const isConversationAssistantSidebarActive = panelId === CONVERSATION_ASSISTANT_CONTAINER_ID;
	const sidebarApi = useCreateRovoExperienceSidebarController();

	const toggleConversationAssistant = useCallback(() => {
		if (
			fg('aifc_create_enabled') ||
			expValEquals('rovo_chat_refresh_v1_experiment', 'isRenderRefreshEnabled', true)
		) {
			toggleConversationAssistantUIMode({
				targetMode: ConversationAssistantUIModes.SIDEBAR,
				sidebarApi,
			});
		} else {
			if (isConversationAssistantSidebarActive) {
				rightSidebarContext.close(CONVERSATION_ASSISTANT_CONTAINER_ID);
			} else {
				rightSidebarContext.open(
					CONVERSATION_ASSISTANT_CONTAINER_ID,
					CONVERSATION_ASSISTANT_CONTAINER_WIDTH,
				);
			}
		}
	}, [
		toggleConversationAssistantUIMode,
		isConversationAssistantSidebarActive,
		rightSidebarContext,
		sidebarApi,
	]);

	return {
		toggleConversationAssistant,
		isConversationAssistantSidebarActive,
	};
};
